module.exports = new __parcel__URL__("WETH.6226dbd9.svg").toString();